import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const STORAGE_KEY = "retailhub_cart_v1";

function loadCart() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(loadCart);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.product_id);
      if (found) {
        return prev.map((i) => i.product_id === product.product_id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        product_id: product.product_id,
        name: product.name, brand: product.brand,
        price: product.price, image: product.image, quantity: qty,
      }];
    });
    setOpen(true);
  };

  const removeItem = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const updateQty = (pid, qty) => setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i));
  const clearCart = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
